import { Button, Row, Select } from 'antd'
import axios from 'axios'

downloadFile = (fileId) ->
  options = {
    method: 'GET'
    headers: { 'Authorization': Weaver.getInstance().currentUser().authToken }
    url: '/api/file/download'
    responseType: 'blob'
    params: payload: {
      target: Weaver.getInstance().coreManager.currentProject.projectId
      fileId
      deleteOnFinish: true
    }
  }

  axios(options)
    .then((response) ->
      url = window.URL.createObjectURL(new Blob([response.data]))
      link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'export.xlsx')
      document.body.appendChild(link)
      link.click()
    )

export default {
  memberKey: 'rdf:type'
  nameKeys: [
    'iim:Thing_hasNameByLiteral_Xsd'
    'iim:ComputerFile_isLocatedAtByLiteral_Xsd'
    'iim:Thing_hasIdentificationByLiteral_Xsd'
    'iim:Quantity_hasValueByLiteral_Xsd'
  ]
  fileAttrMap: { # map of classe/attributeKeys which represent downloadable resources
    'iim:ComputerFile': {
      minioId: true
    }
  }

  relationAttributes: [ # NB show the coloured dot
    { relKey: 'iim:Statement_hasStatusByLibraryClass_ClassOfStatementStatus' }
    { relKey: 'iim:Statement_isValidInTheContextOf_Baseline' }
    { relKey: 'iim:Statement_hasAccessRightByLibraryClass_ClassOfRdfStatementAccessRights' }
    { relKey: 'iim:Statement_isCreatedBy_Party' }
  ]

  disabledRelations: [
    'dc:source'
  ]

  actionsPages: [{
      key: 'clear-space'
      title: 'Clear Space'
      component: 'clear_space'
  }, {
    key: 'upload-pallas-excel'
    title: 'Upload Pallas Excel'
    component: 'upload_file'
    service: {
      name: 'weaver-importer-exporter',
      call: 'import',
      storeFile: true,
      staticArgs: ['pallas']
      config: { wipe: false, skipValidation: false, rdlProjectId: 'pallas-rdl-2', iimProjectId: 'pallas-squash-iim' }
    }
  }, {
    key: 'upload-excel-path'
    title: 'Upload Excel Path'
    component: 'upload_file'
    service: { name: 'weaver-importer-exporter', call: 'import', staticArgs: ['excel-path'], config: {wipe: false, memberKey: 'type'}  }
  }, {
    key: 'generate-excel'
    title: 'Generate Excel'
    component: 'select_node'
    componentConf: {
      query: new Weaver.Query().hasRelationOut('rdf:type', new Weaver.Query().restrict('iim:Baseline'))
      buttonLabel: 'Generate excel file.'
      handleSelect: (nodeId, startPlugin) ->
        startPlugin([], { baseline: nodeId })
      handleResponse: (response) ->
        <Row style={{ margin: '40px 0 20px' }}>
          <Button onClick={ -> downloadFile(response.fileId)}>
            Download excel file
          </Button>
        </Row>
    }
    service: {
      name: 'weaver-importer-exporter',
      call: 'export',
      staticArgs: ['pallas']
      config: { wipe: false, filename: 'export.xlsx' }
      verb: 'export'
    }
  }, {
    key: 'remove-baseline'
    title: 'Remove baseline'
    component: 'select_node'
    componentConf: {
      query: new Weaver.Query().hasRelationOut('rdf:type', new Weaver.Query().restrict('iim:Baseline'))
      buttonLabel: 'Remove the data for this baseline.'
      handleSelect: (nodeId, startPlugin) ->
        startPlugin([], { baseline: nodeId })
      handleResponse: (response) ->
        <Row style={{ margin: '40px 0 20px' }}></Row>
    }
    service: {
      name: 'weaver-importer-exporter',
      call: 'export',
      staticArgs: ['pallas-remove-baseline']
      config:  {}
      verb: 'remove'
    }
  }, {
    key: 'generate-turtle'
    title: 'Generate Turtle'
    component: 'generate_file'
    service: {
      name: 'rdf-export-service',
      call: 'historyToRdf',
      config: { rdlVersion: '8.0.0', iimVersion: '5.0.0' }
    }
  }]

  groupings: []
  queries: []
}
